import * as React from "react";

export const renderEventsCount = (count: number, componentPrefix: string) => {
    return (
        <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__events-count`}>
            <span className={`rj-ev-list__${componentPrefix}__count`}>{count}</span>
        </div>
    )
}